// This icon file is generated automatically.
var PtoArrDownloadOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M15.8 20.66c.1.12.3.12.4 0l3.5-4.43a.25.25 0 00-.2-.4h-2.32V5.24a.25.25 0 00-.25-.25h-1.87a.25.25 0 00-.25.25v10.57H12.5c-.2 0-.32.24-.2.4l3.5 4.44zm11.64-1.1h-1.88a.25.25 0 00-.25.25v4.82H6.7V19.8a.25.25 0 00-.25-.25H4.56a.25.25 0 00-.25.25V26a1 1 0 001 1H26.7a1 1 0 001-1v-6.19a.25.25 0 00-.25-.25z", "fill-rule": "nonzero" } }] }, "name": "pto-arr-download", "theme": "outlined" };
export default PtoArrDownloadOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoArrDownloadOutlined.js
// module id = 3866
// module chunks = 0